export default import.meta.ROLLDOWN_FILE_URL_w49EQJN2ZYUV2EUOJMB1ug